import { store } from "../store/index";
import {
  filterCourse,
  get,
  createCourse,
  update,
  removeCourse,
  listCourses,
} from "../store/actions/CourseActions";

/**
 * Create Course
 */
export const addCourse = async (values) => {
  const objSend = { ...values };
  const formData = objectToFormData(objSend);
  const result = await store.dispatch(createCourse(formData));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

const objectToFormData = (obj) => {
  const formData = new FormData();
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      formData.append(key, obj[key]);
    }
  }
  return formData;
};

/**
 * Get Course
 */
export const getCourse = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(get(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Course
 */
export const updateCourse = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(update(objSend, uuid));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Course
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterCourse(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Course
 */
export const deleteCourse = async (uuid) => {
  const result = await store.dispatch(removeCourse([uuid]));
  if (result?.payload) {
    return result.payload;
  }
  return null;
};

export const listCourse = async (filter) => {
  const result = await store.dispatch(listCourses(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
